// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export const custom = {};
//# sourceMappingURL=inspect.browser.js.map